import * as applicationApis from './applicationApis'
import * as planApis from './planApis'
import * as authApis from './authApis'
import * as appApis from './appApis'
import * as emailApis from './emailApis'

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  ...applicationApis,
  ...planApis,
  ...authApis,
  ...appApis,
  ...emailApis
}
